import React from "react";
import { Route } from "react-router-dom";

const Articles = React.lazy(() => import("../containers/Articles"));
const ClientAccounts = React.lazy(() => import("../containers/ClientAccounts"));
const DedcuctionOfOtherInvoices = React.lazy(
  () => import("../containers/DedcuctionOfOtherInvoices")
);
const GenerateRemit = React.lazy(() => import("../containers/GenerateRemit"));
const ImportRemitReceipt = React.lazy(
  () => import("../containers/ImportRemitReceipt")
);
const InvoicingProfiles = React.lazy(
  () => import("../containers/InvoicingProfiles")
);
const ItemTypes = React.lazy(() => import("../containers/ItemTypes"));
const LedgerAccounts = React.lazy(() => import("../containers/LedgerAccounts"));
const ManagePayments = React.lazy(() => import("../containers/ManagePayments"));
const ManagePaymentsOld = React.lazy(
  () => import("../containers/ManagePaymentsOld")
);
const OrderLines = React.lazy(() => import("../containers/OrderLines"));
const ClientInvoices = React.lazy(() => import("../containers/ClientInvoices"));
const ClientOrders = React.lazy(() => import("../containers/ClientOrders"));
const ManualOrders = React.lazy(() => import("../containers/ManualOrders"));
const PaymentSearch = React.lazy(() => import("../containers/PaymentSearch"));
const RegisterPayments = React.lazy(
  () => import("../containers/RegisterPayments")
);

const RemitHistory = React.lazy(() => import("../containers/RemitHistory"));
const Remit = React.lazy(() => import("../containers/Remit"));
const RemitDetails = React.lazy(() => import("../containers/RemitDetails"));
const TransactionProfiles = React.lazy(
  () => import("../containers/TransactionProfiles")
);
const VATCode = React.lazy(() => import("../containers/VATCode"));
const ImportPayments = React.lazy(() => import("../containers/ImportPayments"));
const InvoiceList = React.lazy(() => import("../containers/InvoiceList"));
const PaymentsImportSummary = React.lazy(
  () => import("../containers/PaymentImportSummary")
);
const CoveringSequence = React.lazy(
  () => import("../containers/CoveringSequence")
);
const ProvisionProfiles = React.lazy(
  () => import("../containers/ProvisionProfiles")
);
const RegisterJournal = React.lazy(
  () => import("../containers/RegisterJournal")
);
const CreditorInvoiceDetails = React.lazy(
  () => import("../containers/CreditorInvoiceDetails")
);


export default [
  <Route
    key="/articles"
    path={"/articles"}
    element={<Articles />}
  />,
  <Route
    key="/client-accounts"
    path={"/client-accounts"}
    element={<ClientAccounts />}
  />,
  <Route
    key="/deduct-invoices"
    path={"/deduct-invoices"}
    element={<DedcuctionOfOtherInvoices />}
  />,
  <Route
    key="/generate-remit"
    path={"/generate-remit"}
    element={<GenerateRemit />}
  />,
  <Route
    key="/import-remit-receipt"
    path={"/import-remit-receipt"}
    element={<ImportRemitReceipt />}
  />,
  <Route
    key="/invoicing-profiles"
    path={"/invoicing-profiles"}
    element={<InvoicingProfiles />}
  />,
  <Route
    key="/item-types"
    path={"/item-types"}
    element={<ItemTypes />}
  />,
  <Route
    key="/ledger-accounts"
    path={"/ledger-accounts"}
    element={<LedgerAccounts />}
  />,
  <Route
    key="/manage-payments"
    path={"/manage-payments"}
    element={<ManagePayments />}
  />,
  <Route
    key="/manage-payments-old"
    path={"/manage-payments-old"}
    element={<ManagePaymentsOld />}
  />,
  <Route
    key="/order-lines"
    path={"/order-lines"}
    element={<OrderLines />}
  />,
  <Route
    key="/orders"
    path={"/orders"}
    element={<ClientOrders />}
  />,
  <Route
    key="/manual-orders"
    path={"/manual-orders"}
    element={<ManualOrders />}
  />,
  <Route
    key="/payment-search"
    path={"/payment-search"}
    element={<PaymentSearch />}
  />,
  <Route
    key="/register-payments"
    path={"/register-payments"}
    element={<RegisterPayments />}
  />,
  <Route
    key="/remit-history"
    path={"/remit-history"}
    element={<RemitHistory />}
  />,
  <Route key="/remit" path={"/remit"} element={<Remit />} />,
  <Route
    key="/transaction-profiles"
    path={"/transaction-profiles"}
    element={<TransactionProfiles />}
  />,
  <Route
    key="/import-payments"
    path={"/import-payments"}
    element={<ImportPayments />}
  />,
  <Route
    key="/manage-client-invoices"
    path={"/manage-client-invoices"}
    element={<ClientInvoices />}
  />,
  <Route key="/vat-code" path={"/vat-code"} element={<VATCode />} />,
  <Route
    key="/invoice-list"
    path={"/invoice-list"}
    element={<InvoiceList />}
  />,
  <Route
    key="/payments-import-summary"
    path={"/payments-import-summary"}
    element={<PaymentsImportSummary />}
  />,
  <Route
    key="/covering-sequence"
    path={"/covering-sequence"}
    element={<CoveringSequence />}
  />,
  <Route
    key="/provision-profiles"
    path={"/provision-profiles"}
    element={<ProvisionProfiles />}
  />,
  <Route
    key="/manual-journal-entry"
    path={"/manual-journal-entry"}
    element={<RegisterJournal />}
  />,
  <Route
  key="/creditor-invoice-details"
  path={"/creditor-invoice-details"}
  element={<CreditorInvoiceDetails />}
  />,
<Route
    key="/remit-details"
    path={"/remit-details"}
    element={<RemitDetails />}
  />,
];
